import React, { useRef, useEffect } from 'react';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';

import InputLabel from '~/components/InputLabel';
import StyledTextField from '~/styles/components/StyledTextField';

import { Container } from './styles';

function Input({ label, type, name, ...rest }) {
  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container>
      {label && <InputLabel>{label}</InputLabel>}

      <StyledTextField
        onFocus={clearError}
        id={fieldName}
        inputRef={inputRef}
        defaultValue={defaultValue}
        size="small"
        type={type}
        variant="outlined"
        inputProps={{
          min: type === 'number' ? 1 : undefined, // For input type "number"
        }}
        error={error !== undefined}
        helperText={error}
        {...rest}
      />
    </Container>
  );
}

Input.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
};

Input.defaultProps = {
  label: null,
  type: 'text',
};

export default Input;
